import React, { useCallback, useEffect, useState } from "react";
import {
  AgriProductsAPMC,
  AmendmentStaffMarketCommittee,
  AppointmentSecretaryAPMC,
  BuyingLandAPMC,
  ContractualAppointmentSecretaryAPMC,
  PayComission,
  PermAppointmentSecretaryAPMC,
  PromotionSecretaryMarketCommittee,
  ProposalDonation,
  ProposalLoan,
  SellingLandAPMC,
  StudyTour,
  YardAPMC,
} from "../../../LandDistrict/Json/AllData";
import CommonSelect, { Option } from './commonSelect'
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SingleView from "../../../allPages/components/SingleForm";
import {
  submitApmcApproveRejectApplication,
  updateField,
} from "../../../../auth/services/privateapicalling";

import ActionButtons from "./ActionButtons";
import { toast } from "react-toastify";
// import DownloadFormApplication from "./DownloadForm";

interface Page1Props {
  type: string | null;
  handleFileChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    documentName
  ) => void;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    fieldName
  ) => void;
  formData: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  existData: any;
  applicationId: any;
  prepareRejectedField:()=>void;
  transaction: any;
  formType: any;
  editFieldValues: any;
  setEditFieldValues: any;
  editFiles: any;
  setEditFiles: any;
  getExistedApplication: () => void;
  unverifiedFields?: string[];
  userRole?: string;
  isFieldUnverified?: (fieldName: string) => boolean;
  getFieldStatus?: (fieldName: string) => { isVerified: boolean; comment: string; status: string } | null;
  resubmittedFields: any;
  setResubmittedFields: (fields: any) => void;
  validationErrors?: { [key: string]: string };
  districtOptions?: any[];
  uploadLoading: boolean;
  commentsubmitted?:boolean;
  handleResubmissionInputChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, fieldName: string, annexureType: string) => void;
  handleResubmissionPercentageChange?: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string, annexureType: string) => void;
  handleResubmissionFileChange?: (e: React.ChangeEvent<HTMLInputElement>, fieldName: string, annexureType: string) => void;
}

const RejPage = ({
  formData,
  setFormData,
  handleFileChange,
  handleInputChange,
  editFieldValues,
  setEditFieldValues,
  prepareRejectedField,
  editFiles,
  setEditFiles,
  type,
  existData,
  applicationId,
  transaction,
  getExistedApplication,
  userRole,
  isFieldUnverified,
  getFieldStatus,
  unverifiedFields = [], // <-- add default value here
  resubmittedFields,
  setResubmittedFields,
  validationErrors = {},
  districtOptions = [],
  handleResubmissionInputChange = () => {},
  handleResubmissionPercentageChange = () => {},
  handleResubmissionFileChange = () => {},
  uploadLoading,
  commentsubmitted
}: Page1Props) => {
  const navigate = useNavigate();
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail.Role.Role_Identifier;

  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);

  // State variables for form management
  const [verified, setVerified] = useState<{ [key: string]: boolean }>({});
  const [updatedIndexes, setUpdatedIndexes] = useState<number[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const [fieldComments, setFieldComments] = useState<{ [key: string]: string }>(
    {}
  );
const [pendingVerified, setPendingVerified] = useState<{ [key: string]: boolean }>({});
  // Log overlay states
  const [logFieldKey, setLogFieldKey] = useState<string | null>(null);
  const [showLogOverlay, setShowLogOverlay] = useState(false);
  const [transactionData, setTransactionData] = useState([]);

  // Add this with your other state variables
  const [updatedFields, setUpdatedFields] = useState<{ [key: string]: any }>(
    {}
  );

  // Add this useEffect for managing body overflow when overlay is shown
  useEffect(() => {
    if (showLogOverlay) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showLogOverlay]);
  

  let heading = "";

  const getDataField = () => {
  
    const typeNum = Number(type);
   
    switch (typeNum) {
      case 39:
        heading = "Buying Land";
        return BuyingLandAPMC;
      case 40:
        heading = "Selling Land";
        return SellingLandAPMC;
      case 41:
        heading =
          "To control Agriculture products under the APMC - Application under Form-8";
        return AgriProductsAPMC;
      case 42:
        heading = "Declaration of the main yard/sub-yard of APMC";
        return YardAPMC;
      case 43:
        heading =
          " the new/permanent or temporary appointment of the Secretary in the Market Committee";
        return AppointmentSecretaryAPMC;
      case 44:
        heading = "Permanent appointment of Secretary in the Market Committee";
        return PermAppointmentSecretaryAPMC;
      case 45:
        heading =
          "Regarding amendment in the staff schedule of the Market Committee";
        return AmendmentStaffMarketCommittee;
      case 46:
        heading =
          "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
        return PromotionSecretaryMarketCommittee;
      case 47:
        heading =
          "Regarding contractual appointment of Secretary / employee after retirement";
        return ContractualAppointmentSecretaryAPMC;
      case 48:
        heading =
          "Regarding approval of 7th Pay Commission for Secretary / employee";
        return PayComission;
      case 49:
        heading = " Proposals regarding donation";
        return ProposalDonation;
      case 50:
        heading = "Proposals regarding loan";
        return ProposalLoan;
      case 51:
        heading = "Approval for Study Tours";
        return StudyTour;
      default:
        return BuyingLandAPMC;
    }
  };

  const dataField = getDataField();

  const selectFn = (response: any) => {
    const options = [
      { value: "option1", label: "Option 1" },
      { value: "option2", label: "Option 2" },
    ];

    const handleChange = (selectedOption: Option | null, fieldName: string) => {
      setFormData((prev) => {
        const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
        const index = arr.findIndex((item) => item.fieldName === fieldName);
        if (index !== -1) {
          arr[index] = { ...arr[index], value: selectedOption?.value || "" };
        } else {
          arr.push({
            value: selectedOption?.value || "",
            fieldName: fieldName,
          });
        }
        return { ...prev, [fieldName]: arr };
      });
    };

    const selectedValue = options.find(
      (opt) => opt.value === formData[response?.responseVal]
    );

    return (
      <CommonSelect
        options={options}
        value={selectedValue}
        name={response?.responseVal}
        onChange={(e) => handleChange(e, response?.fieldName)}
        placeholder={`Select ${response?.responseVal}`}
        className="w-100"
      />
    );
  };

  const inputFn = (response: any) => {
    return (
      <input
        type="text"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={
          existData?.annexureOne?.[response?.fieldName]?.data?.find(
            (item) => item.fieldName === response?.responseVal
          )?.value || ""
        }
        onChange={(e) => handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };

  const numberFn = (response: any) => {
    return (
      <input
        type="number"
        className="p-2 form-control"
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={
          existData?.annexureOne?.[response?.fieldName]?.data?.find(
            (item) => item.fieldName === response?.responseVal
          )?.value || ""
        }
        onChange={(e) => handleInputChange(e, response?.fieldName)}
        disabled={true}
      />
    );
  };

  const radioFn = (response: any) => {
  
    return (
      <div className="d-flex w-100 gap-2">
        <input
          type="radio"
          name={"readOnly"+response?.responseVal}
          value="yes"
          disabled={true}
          checked={
            existData?.annexureOne?.[response?.fieldName]?.data?.find(
              (item) => item.fieldName === response?.responseVal
            )?.value === "yes"
          }
          onChange={(e) => handleInputChange(e, response?.fieldName)}
        />{" "}
        Yes
        <input
          type="radio"
          name={"readOnly"+response?.responseVal}
          value="no"
          disabled={true}
          checked={
            existData?.annexureOne?.[response?.fieldName]?.data?.find(
              (item) => item.fieldName === response?.responseVal
            )?.value === "no"
          }
          onChange={(e) => handleInputChange(e, response?.fieldName)}
        />{" "}
        No
      </div>
    );
  };

  const percentageFn = (response: any) => (
    <input
      className="form-control"
      type="text"
      inputMode="decimal"
      name={response?.responseVal}
      placeholder="0 - 100"
      value={
        existData?.annexureOne?.[response?.fieldName]?.find(
          (item) => item.fieldName === response?.responseVal
        )?.value || ""
      }
      onChange={(e) => handleInputChange(e, response?.fieldName)}
      disabled={true}
    />
  );
  const dateFn = (response: any) => {
    return (
      <div className="d-flex flex-column">
        <input
          type="date"
          className={`p-2 form-control  ? 'border border-danger' : ''}`}
          name={response?.responseVal}
          value={
            existData?.annexureOne?.[response?.fieldName]?.data?.find(
              (item) => item.fieldName === response?.responseVal
            )?.value || ""
          }
          onChange={(e) => {
            handleInputChange(e, response?.fieldName);
          }}
          disabled={true}
        />

        <small className="text-muted mt-1 ms-1">{response.responseName}</small>
      </div>
    );
  };
  const fileFn = (response: any) => (
    <input
      className="form-control"
      type="file"
      onChange={(e) => handleFileChange(e, response?.fieldName)}
      name={response?.responseVal}
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
      id={response?.responseVal}
    />
  );

  const fileButtonFn = (fieldName, docName) => {
    const docData = existData?.annexureOne?.[fieldName];
    const docId = docData?.data.find(
      (data) => data.documentName == docName
    )?.docId;

    return (
      <Link
        to="#"
        data-bs-toggle="modal"
        data-inert={true}
        data-bs-target="#apmc_modal"
        className="btn btn-outline-info w-100"
        onClick={() => {
          setSelectedDocId(docId);
        }}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
    );
  };



  const handleCloseOverlay = () => {
    setShowLogOverlay(false);
  };

  // Track missing subfields for required error display
  const [missingSubfields, setMissingSubfields] = useState({});

  const handleFinalSubmit = async (status, appStatusLevel) => {
    try {

   if(roleIdentifier === "JC"||roleIdentifier === "SC")
      {   if(!commentsubmitted){
        toast.error("Please resolve all queries or add comment for fields before submitting the form.",{
          position: "top-right",
          autoClose: 3000,
        });
        return
      }}
if (roleIdentifier === "SEC") {
  const missingFields = [];
  const missingMap = {};

  unverifiedFields.forEach(fieldName => {
    // Find the field definition in dataField
    const fieldDef = dataField.find(f => f.fieldName === fieldName);
    if (!fieldDef) return;

    // Get all required subfields for this field (e.g., all responseVal or documentName)
    const requiredSubfields = fieldDef.response.map(r => r.responseVal );

    // Get all submitted subfields for this field
    const submittedSubfields = (resubmittedFields[fieldName] || []).map(
      item => item.fieldName || item.documentName || item.responseVal
    );

    // Check if any required subfield is missing
    requiredSubfields.forEach(subfield => {
      if (!submittedSubfields.includes(subfield)) {
        missingFields.push(`${fieldName} - ${subfield}`);
        if (!missingMap[fieldName]) missingMap[fieldName] = [];
        missingMap[fieldName].push(subfield);
      }
    });
  });

  setMissingSubfields(missingMap);

  if (missingFields.length > 0) {
    toast.error("Please update all unverified subfields before resubmitting.", {
      position: "top-right",
      autoClose: 3000,
    });
    return;
  }
}
       const annexureOne = Object.fromEntries(
      Object.entries(resubmittedFields).map(([fieldName, arr]) => [
        fieldName,
        { data: arr }
      ])
    );
    const rejectedFieldName = Object.keys(resubmittedFields).map(key => ({
  annexureType: "annexureOne",
  key: key
}));

      const formData = {
        // comment: editComment,
        status: status,
        applicationType: "form",
        appStatusLevel: appStatusLevel,
        comment:"",

        applicationId: applicationId,
        schemeId: existData?.scheme?.id,
                ...((roleIdentifier === "JC"||roleIdentifier === "SC") && {
    rejectedFieldName:prepareRejectedField(),
 
  }),
        ...(roleIdentifier === "SEC" && {
    rejectedFieldName:rejectedFieldName,
    reSubmittedFields: {
      annexureOne,
    },
  }),
      };

      const submitData = await submitApmcApproveRejectApplication(
        formData,
        token
      );

      if (submitData.success) {
            toast.success(
            <>
              Form submitted successfully <br /> ફોર્મ સફળતાપૂર્વક સબમિટ કર્યું
            </>,
            {
              position: "top-right",
              style: { fontSize: "1.2rem", padding: "16px" },
            }
          );
        if(userRole==="SEC"){
          navigate("/forms-application");
        }
        else {
          // alert("Form submitted successfully!");
      
          navigate("/apmc-forms-application");
        }
        
      } else {
        // alert("Submission failed, please try again.");
        toast.error(
          <>
            Submission failed, please try again <br />
            સબમિશન નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      }
    } catch (error) {
     
    }
  };

  // Handle verify button - NO VALIDATION
  const handleVerifiedChange = (fieldIndex: string) => {
    setPendingVerified((prev) => ({
    ...prev,
    [fieldIndex]: !prev[fieldIndex],
  }));
  };

  // Add this new function after your existing handler functions
  const handleUpdateSubmit = async (index: number, responses: any[]) => {
    
   
 const isVerified = pendingVerified[index] === true ? true : false;

  // use isVerified in your payload
  // after successful submit:
  setVerified((prev) => ({
    ...prev,
    [index]: isVerified,
  }));
    const oldValue: any[] = [];
    const newValue: any[] = [];
    const field = responses.find((res) => res?.fieldName)?.fieldName
      ? responses.find((res) => res?.fieldName)?.fieldName
      : responses.find((res) => res.responseVal)?.responseVal;
    
    // Build oldValue and newValue using editFieldValues and editFiles
    const fieldDataArray = existData?.annexureOne?.[field]?.data;
   
   if (Array.isArray(fieldDataArray)) {
      // Handle input/text fields (editFieldValues: Record<string, Array<Record<string, any>>>)
      Object.entries(editFieldValues).forEach(([fieldKey, updatedArr]: any) => {
        // updatedArr is an array of objects, each with { fieldName, value }
        if (Array.isArray(updatedArr)) {
          updatedArr.forEach((updatedObj: any) => {
            // Old value: get previous value from existData
            const previousField = fieldDataArray.find(
              (item: any) => item?.fieldName === updatedObj.fieldName
            );
            if (previousField) {
              oldValue.push({
                fieldValue: previousField?.value || "",
                fieldName: updatedObj.fieldName,
                fieldType: "string",
              });
            }
            // New value: use updated value
            newValue.push({
              fieldValue: updatedObj.value,
              fieldName: updatedObj.fieldName,
              fieldType: "string",
            });
          });
        }
      });

      // Handle document fields (editFiles: Record<string, Array<Record<string, any>>>)
      Object.entries(editFiles).forEach(([fieldKey, fileArr]: any) => {
        // fileArr is an array of objects, each with { documentName, docId }
        if (Array.isArray(fileArr)) {
          fileArr.forEach((fileObj: any) => {
            // Old value: get previous docId for this documentName (not fieldName)
            const previousDoc = fieldDataArray.find(
              (item: any) => item?.documentName === fileObj?.documentName
            );
            if (previousDoc) {
              oldValue.push({
                fieldValue: previousDoc.docId || "",
                fieldName: previousDoc?.documentName,
                fieldType: "doc",
              });
            }
            // New value: use docId if available, else null
            newValue.push({
              fieldValue: fileObj?.docId || null,
              fieldName: fileObj?.documentName,
              fieldType: "doc",
            });
          });
        }
      });
    }

  

    // Determine if field is updated (oldValue and newValue differ)
    let isUpdated = JSON.stringify(oldValue) !== JSON.stringify(newValue);
    isUpdated = newValue.length !== 0 ? true : false;
    const transaction = [
      {
        oldValue,
        newValue,
        transactionBy: roleIdentifier,
        status: existData.status,
        appStatusLevel: existData.appStatusLevel,
      },
    ];
if (isUpdated) {
   setUpdatedIndexes((prev) => [...prev, index]);
}
    const payload = {
      couchId: existData?.applicationDataId,
      fieldUpdated: field,
      isVerified: isVerified,
      isUpdated: isUpdated,
      comment: fieldComments[responses[0]?.fieldName]
        ? fieldComments[responses[0]?.fieldName]
        : "",
      applicationType: "form",
      annexureUpdated: "annexureOne",
      [`${field}`]: {
        transaction,
      },
    };

  

    try {
      const submitTransaction = await updateField(payload, token);
    

      if (submitTransaction?.result?.ok) {
       
        setEditingIndex(null);
        
        setFieldComments((prev) => ({
          ...prev,
          [responses[0]?.fieldName]: "",
        }));
        setUpdatedFields({});
        setEditFieldValues({});
        setEditFiles({});

        getExistedApplication();

        toast.success(
          <>
            Field updated and submitted successfully <br />
            ફીલ્ડ અપડેટ અને સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      } else {
      
        setUpdatedFields({});
        // alert('Update failed. Please try again.');
        toast.error(
          <>
            Update failed. Please try again <br />
            અપડેટ નિષ્ફળ થયું. કૃપા કરીને ફરી પ્રયાસ કરો.
          </>,
          {
            position: "top-right",
            style: { fontSize: "1.2rem", padding: "16px" },
          }
        );
      }
    } catch (error) {
   
      setEditingIndex(null);
   
      setFieldComments((prev) => ({ ...prev, [responses[0]?.fieldName]: "" }));
      setUpdatedFields({});
      setEditFieldValues({});
      setEditFiles({});
      // alert('An error occurred during update. Please try again.');
      toast.error(
        <>
          An error occurred during update. Please try again <br />
          અપડેટ દરમિયાન એક ભૂલ આવી. કૃપા કરીને ફરી પ્રયાસ કરો.
        </>,
        {
          position: "top-right",
          style: { fontSize: "1.2rem", padding: "16px" },
        }
      );
    }
  };



  // Handler functions for ActionButtons
  const handleEditingToggle = (index: number) => {
    setEditingIndex(index === -1 ? null : index);
  };

  const handleCommentChange = useCallback(
    (fieldName: string, comment: string) => {
      setFieldComments((prev) => ({ ...prev, [fieldName]: comment }));
    },
    []
  );

  useEffect(() => {
  if (!existData || !existData.annexureOne || !dataField) return;

  const newVerified: { [key: string]: boolean } = {};
  const newUpdatedIndexes: number[] = [];

  dataField.forEach((item, index) => {
    let isVerifiedForRole = false;
    let isUpdatedForRole = false;

    item.response.forEach((r) => {
      const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];
      // Find last transaction for this role
      const lastRoleTx = transactions.filter(tx => tx.transactionBy === roleIdentifier).pop();
      if (lastRoleTx) {
        if (lastRoleTx.isVerified === true) {
          isVerifiedForRole = true;
        }
        if (lastRoleTx.isUpdated === true) {
          isUpdatedForRole = true;
        }
      }
    });

    if (isVerifiedForRole) {
      newVerified[index] = true;
    }
    if (isUpdatedForRole) {
      newUpdatedIndexes.push(index);
    }
  });

  setVerified(newVerified);
  setUpdatedIndexes(newUpdatedIndexes);
}, [existData, roleIdentifier, dataField]);

function renderInputElement(
  responseType: string,
  fieldName: string,
  annexureType: string = "annexureOne",
  newobj:any
): React.ReactNode {
  const errorKey = `${annexureType}_${fieldName}`;
  const hasError = validationErrors && validationErrors[errorKey];
  const isFieldUnverifiedForValidation = unverifiedFields.includes(fieldName);
  const shouldShowValidation = userRole === 'SEC' && isFieldUnverifiedForValidation && hasError;
  const inputClassName = `form-control ${shouldShowValidation ? 'border-danger' : ''}`;
  const selectClassName = `form-select ${shouldShowValidation ? 'border-danger' : ''}`;
  const renderError = () => {
    if (!shouldShowValidation) return null;
    return (
      <div className="mt-1">
        <span className="text-danger small d-flex align-items-center">
          <i className="feather feather-alert-circle me-1"></i>
          {hasError}
        </span>
      </div>
    );
  };

  switch (responseType) {
    case "input": {
      // Show required error if this subfield is missing
      const isMissing = missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <input
            type="text"
            className={inputClassName}
            name={newobj?.responseVal}
            placeholder={`Enter ${fieldName}`}
            value={resubmittedFields?.[newobj?.fieldName]?.find(
              (item) => item.fieldName === newobj?.responseVal
            )?.value || ""}
            onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType)}
          />
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
        </div>
      );
    }
    case "date": {
      // Show required error if this subfield is missing
      const isMissing = missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <input
            type="date"
            className={inputClassName}
            name={newobj?.responseVal}
            placeholder={`Enter ${fieldName}`}
            value={resubmittedFields?.[newobj?.fieldName]?.find(
              (item) => item.fieldName === newobj?.responseVal
            )?.value || ""}
            onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType)}
          />
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
        </div>
      );
    }
    case "select": {
      const isMissing = missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <select
            className={selectClassName}
            name={newobj?.responseVal}
            value={resubmittedFields?.[newobj?.fieldName]?.find(
              (item) => item.fieldName === newobj?.responseVal
            )?.value || ""}
            onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType)}
          >
            <option value="">Select option</option>
            {districtOptions?.map(option => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
        </div>
      );
    }
    case "radio": {
      const isMissing = missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <div className="d-flex gap-3">
            <label>
              <input
                type="radio"
                name={newobj?.responseVal}
                value="yes"
                checked={resubmittedFields?.[newobj?.fieldName]?.find(
                  (item) => item.fieldName === newobj?.responseVal
                )?.value === "yes"}
                onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType)}
              /> Yes
            </label>
            <label>
              <input
                type="radio"
                name={newobj?.responseVal}
                value="no"
                checked={resubmittedFields?.[newobj?.fieldName]?.find(
                  (item) => item.fieldName === newobj?.responseVal
                )?.value === "no"}
                onChange={(e) => handleResubmissionInputChange(e, fieldName, annexureType)}
              /> No
            </label>
          </div>
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
        </div>
      );
    }
    case "percentage": {
      const isMissing = missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <input
            type="text"
            inputMode="decimal"
            className={inputClassName}
            name={newobj?.responseVal}
            placeholder="0-100"
            value={resubmittedFields?.[newobj?.fieldName]?.find(
              (item) => item.fieldName === newobj?.responseVal
            )?.value || ""}
            onChange={(e) => handleResubmissionPercentageChange(e, fieldName, annexureType)}
          />
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
        </div>
      );
    }
    case "button":
    case "file": {
      const isMissing =
        missingSubfields?.[newobj?.fieldName]?.includes(newobj?.responseVal);
      return (
        <div>
          <input
            type="file"
            className={inputClassName}
            name={newobj?.responseVal}
            onChange={(e) => handleResubmissionFileChange(e, fieldName, annexureType)}
            accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
          />
          {renderError()}
          {isMissing && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Required
              </span>
            </div>
          )}
         {resubmittedFields[fieldName] && (
  (() => {
    const doc = resubmittedFields[fieldName].find(
      d => d.documentName === newobj?.responseVal
    );
    return doc ? (
      <small className="text-success mt-1 d-block">
        Uploaded: {doc.fileName}
      </small>
    ) : null;
  })()
)}
        </div>
      );
    }
    default:
      return <div className="text-muted">Unsupported field type: {responseType}</div>;
  }
}
  return (


    <>

       {uploadLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Uploading...</span>
              </div>
              <div className="fw-bold">Uploading, please wait...</div>
            </div>
          </div>
        )}
      <div className="w-100 d-flex align-items-end justify-content-end px-5 mt-2">
        <div className="w-100">
          <h2 className="my-3 mb-4">Proposal for permission for {heading} </h2>
          <div className="d-flex flex-column text-nightblue align-items-center justify-content-center  ">
            <div
              id="table"
              className="w-100 border overflow-hidden bg-white border-secondary rounded mb-3"
            >
           <div
  id="head"
  className="d-flex w-100 rounded-top border-secondary"
  style={{ backgroundColor: "#CCE3FF" }}
>
  <h4 className="col-1 d-flex justify-content-center align-items-center">
    S.No.
  </h4>

  <h4 className="col-5 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">
    પ્રશ્ન (Field)
  </h4>

  <div className="d-flex col-6">
    <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  ((existData?.status === "resubmission"||existData?.status==="reject") &&
   ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"))|| (userRole !== "SEC" && existData?.appStatusLevel !== "pendingAtApmcResubmission")))
    ? "col-6"
    : "col-12"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status === "resubmission"||existData?.status==="reject")&&(userRole==="SEC" &&(existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission")) && (
      <h4 className="col-6 p-2 justify-content-center d-flex align-items-center">
        ક્રિયા (Action)
      </h4>
    )}
  </div>
</div>

              {dataField &&
                dataField.length > 0 &&
                dataField.map((item, index) => {
                  // Only show action buttons for fields that are in unverifiedFields (isVerified === false)
                  const isUnverified = unverifiedFields && unverifiedFields.includes(item.fieldName);
                  return (
                    <React.Fragment key={index}>
                      <div className={`d-flex border-top border-secondary`}>
                        <h4 className={`col-1 d-flex align-items-center justify-content-center`}>
                          {item.fieldNo}
                        </h4>
                        <div className="col-5">
                          <p className={`d-flex align-items-center h-100 p-3 border-start border-end border-secondary ${isUnverified ? 'text-warning fw-bold' : ''}`}> {/* Highlight if unverified */}
                            {item.fieldVal}*
                          </p>
                        </div>

                        <div className="col-6 d-flex ">
                          <div      className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
     ((existData?.status === "resubmission"||existData?.status==="reject") &&
   ( (userRole === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission"||existData?.appStatusLevel==="pendingAtApmcHOResubmission"))|| (userRole !== "SEC" && existData?.appStatusLevel !== "pendingAtApmcResubmission"))) ? "col-6" : "col-12"
      }`}>
                            <div className="w-75 d-flex flex-column p-2 gap-2 ">
                              {item.response.map((newObj, indx) => {
                                const docName = newObj.responseVal;
                                const fieldName = item.fieldName;

                                const inputKey = `${index}_${indx}`;
                                const divVal =
                                  newObj.responseType === "select"
                                    ? selectFn(newObj)
                                    : newObj.responseType === "input"
                                    ? inputFn(newObj)
                                    : newObj.responseType === "number"
                                    ? numberFn(newObj)
                                    : newObj.responseType === "radio"
                                    ? radioFn(newObj)
                                    : newObj.responseType === "percentage"
                                    ? percentageFn(newObj)
                                    : newObj.responseType === "date"
                                    ? dateFn(newObj)
                                    : newObj.responseType === "file"
                                    ? fileButtonFn(fieldName, docName)
                                    : null;
                                return (
                                  <div
                                    className=" d-flex align-items-center justify-content-center"
                                    key={inputKey}
                                  >
                                    {divVal}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                      {  (existData?.status === "resubmission" || existData?.status==="reject") &&   <div className="col-6 d-flex flex-column gap-2 justify-content-center align-items-center p-2">
                             {(roleIdentifier === "JC" || roleIdentifier === "SC") && isUnverified ? (
                              <ActionButtons
                                fieldNo={`${index}`}
                                item={item}
                                verified={verified}
                                editFieldValues={editFieldValues}
                                editFiles={editFiles}
                                fieldComments={fieldComments}
                                updatedIndexes={updatedIndexes}
                                onVerifiedChange={handleVerifiedChange}
                                onEditingToggle={handleEditingToggle}
                                onFieldSubmit={handleUpdateSubmit}
                                onCommentChange={handleCommentChange}
                                editingIndex={editingIndex}
                                pendingVerified={pendingVerified}
                              />
                            ) : 
                            (roleIdentifier === "SEC" && (existData?.appStatusLevel==="pendingAtApmcResubmission" ||existData?.appStatusLevel==="pendingAtApmcHOResubmission")&&isUnverified )?(
                              item.response.map((newObj, indx) => {
                                const fieldName = newObj?.fieldName;
                                const responseType = newObj?.responseType;
                                const inputKey = `${index}_${indx}`;

                                return (
                                  <div className="w-75 d-flex flex-column" key={inputKey}>
                                    {renderInputElement(responseType, fieldName, "annexureOne",newObj)}
                                  </div>
                                );
                              })
                          ):null
                            }
                          </div>}
                        </div>
                        
                      </div>

                      {/* Edit Form */}
                      {editingIndex === index && (
                        <div className="d-flex flex-column border-top border-secondary bg-white p-3">
                          <h4 className="border-bottom border-3 border-success mb-3">
                            Edit Values
                          </h4>

                          {/* File Inputs */}
                          {/* File Inputs */}
                          <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  r.responseType === "file" ||
                                  r.responseType === "button"
                              )
                              .map((r, fileIdx) => (
                                <div
                                  key={fileIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      className="form-control"
                                      type="file"
                                      onChange={(e) => {
                                        const file =
                                          e.target.files?.[0] || null;
                                        // handleEditFileChange(r.responseVal, file);
                                        handleFileChange(e, `${r.fieldName}`);
                                        // Add this line to track in updatedFields (you'll need to handle file upload)
                                        if (file) {
                                          setUpdatedFields((prev) => ({
                                            ...prev,
                                            [r.responseVal]: {
                                              file: file,
                                              documentName: r.responseVal,
                                            },
                                          }));
                                        }
                                      }}
                                      name={r.responseVal}
                                      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
                                      key={
                                        editFiles[r.responseVal]
                                          ? "file-selected"
                                          : "file-empty"
                                      }
                                    />
                               
                                  </div>
                                  {editFiles[r.responseVal] && (
                                    <small className="text-muted mt-1">
                                      Selected: {editFiles[r.responseVal]?.name}
                                    </small>
                                  )}
                                </div>
                              ))}
                          </div>

                           <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  r.responseType === "radio" 
                              )
                              .map((r, fileIdx) => (
                                <div
                                  key={fileIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                     <input
        type="radio"
        name={r?.responseVal}
        value="yes"
        checked={editFieldValues[r?.fieldName]?.find(item=>item.fieldName===r?.responseVal)?.value === "yes"}
                onChange={(e) => {
                  handleInputChange(e, r?.fieldName);
                  // setUpdatedFields((prev) => ({
                  //                         ...prev,
                  //                         [r.responseVal]: e.target.value,
                  //                       }));
                }}
     
      />{" "}Yes
      <input
        type="radio"
        name={r?.responseVal}
        value="no"
        checked={editFieldValues[r?.fieldName]?.find(item=>item.fieldName===r?.responseVal)?.value === "no"}
        onChange={(e) => {
          handleInputChange(e, r?.fieldName);
          //  setUpdatedFields((prev) => ({
          //                                 ...prev,
          //                                 [r.responseVal]: e.target.value,
          //                               }));
        }}
    
      />{" "}No
    </div>
                               
                                  </div>
                              
                              ))}
                          </div>

                          {/* Other Input Types */}
                          <div className="d-flex gap-3 flex-wrap mb-3">
                            {item.response
                              .filter(
                                (r) =>
                                  !["file", "button","radio"].includes(r.responseType)
                              )
                              .map((r, inputIdx) => (
                                <div
                                  key={inputIdx}
                                  className="d-flex flex-column w-25"
                                >
                                  <label className="fw-semibold mb-1">
                                    {r.responseName || r.responseVal}
                                  </label>
                                  <div className="d-flex gap-2 align-items-center">
                                    <input
                                      type={
                                        r.responseType === "number"
                                          ? "number"
                                          : r.responseType === "date"
                                          ? "date"
                                          : "text"
                                      }
                                      className="form-control"
                                      placeholder={`Enter ${r.responseVal}`}
                                      name={r.responseVal}
                                      value={
                                        editFieldValues[r?.fieldName]?.find(item=>item.fieldName===r?.responseVal)?.value || ""
                                      }
                                      onChange={(e) => {
                                        handleInputChange(e, r.fieldName);
                                        setUpdatedFields((prev) => ({
                                          ...prev,
                                          [r.responseVal]: e.target.value,
                                        }));
                                      }}
                                    />
                  
                                  </div>
                                </div>
                              ))}
                          </div>
                            <div className="d-flex flex-column align-items-end w-100 mb-3">
                                <button 
                                className="btn btn-success mt-3 w-25"
                                onClick={() => handleUpdateSubmit(index, item?.response)}>
                                   Submit
                                </button>
                            </div>
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
          <div className="d-flex flex-column justify-content-between mb-4">
         

            <div className="d-flex justify-center justify-item-center w-100">
              {/* {existData?.status === "approvedUnsigned" && (
                <DownloadFormApplication
                  type={type}
                  existData={existData}
                  applicationId={applicationId}
                />
              )} */}
              {existData?.buttonName &&
                existData.buttonName.length > 0 &&
                existData.buttonName[0].appStatusLevel != "schemeGranted" &&
                existData.role !== "" &&
                roleIdentifier === existData.role && (
                  <div className="w-100 d-flex gap-2 flex-column">
                    {!(
                      (["JC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                          "dclerkAfterRejectionAction") ||
                      (["HJC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                          "hoclerkAfterRejectionAction")
                    ) && <div></div>}

                    <div className="d-flex gap-2">
                      {existData.buttonName &&
                        existData?.buttonName.map((button) => (
                          <button
                            key={button.appStatusLevel}
                            className={`btn ${
                              button.status === "reject"
                                ? "btn-danger"
                                : button.status === "permanentReject"
                                ? "btn-secondary"
                                : "btn-success"
                            }`}
                            onClick={() => {
                              handleFinalSubmit(
                                button.status,
                                button.appStatusLevel
                              );
                            }}
                          >
                            {button.buttonLabel==="Forward to senior clerk for forwarding to Higher Authority"?"Approve":button.buttonLabel}
                          </button>
                        ))}
                    </div>
                  </div>
                )}
            </div>
          </div>
           <div className="row p-3">
                                      {existData && existData.status == "approve" && (
                                        <div className="col-sm-12 d-flex justify-content-end">
                                          {/* <button
                                            onClick={() => {
                                              handleDownload();
                                            }}
                                            className="bg-success rounded text-white px-4 py-2"
                                          >
                                            {language.download_license}
                                          </button> */}
            
                                           {(() => {
                                            const latestLicense = existData?.licDoc // Get the last license
            
                                            return latestLicense ? (
                                              <Link
                                                key={latestLicense}
                                                to="#"
                                                data-bs-toggle="modal"
                                                data-inert={true}
                                                data-bs-target="#apmc_modal"
                                                className="btn btn-success align-items-center"
                                                onClick={() => setSelectedDocId(latestLicense)}
                                              >
                                                Download License
                                              </Link>
                                            ) : null;
                                          })()}
                                        </div>
                                      )}
                                    </div>
        </div>
      </div>
      {showLogOverlay && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1055 }}
        >
          <div
            className="bg-white p-4 rounded shadow position-relative overflow-auto"
            style={{ minWidth: "70%", maxHeight: "90%", maxWidth: "800px" }}
          >
            <button
              className="position-absolute top-0 end-0 m-3 btn-close"
              onClick={handleCloseOverlay}
            />

            <div className="d-flex align-items-center gap-2 mb-3">
              <i className="ti ti-history"></i>
              <h4 className="mb-0">Change History - {logFieldKey}</h4>
            </div>

            {/* Transaction Section */}
            {transactionData?.length > 0 && (
              <div className="mt-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="ti ti-report"></i>
                  <h5 className="mb-0">Transaction History</h5>
                </div>

                {transactionData.map((txItem, idx) => (
                  <div key={idx} className="mb-4">
                    <div className="badge bg-info mb-2">{txItem.key}</div>

                    {txItem.data.length === 0 ? (
                      <div className="text-muted">No transaction found.</div>
                    ) : (
                      txItem.data.map(
                        (entry, i) => (
                    
                          (
                            <div
                              key={i}
                              className="border-start border-info border-3 p-3 mb-3 bg-light-subtle rounded"
                            >
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <strong>
                                  Modified By:{" "}
                                  {entry.transactionBy || "Unknown"}
                                </strong>
                                <small className="text-muted">
                                  📅 {entry.createdAt || "-"}
                                </small>
                              </div>
                          {entry.oldValue.length>0 && entry.newValue.length>0&&    <div className="d-flex align-items-center gap-2 mb-2">
                                <span className="text-danger">Old Data:</span>
                                <div className="d-flex flex-column gap-1">
                                  {Array.isArray(entry.oldValue) ? (
                                    entry.oldValue.map((item, i) =>
                                      typeof item === "object" &&
                                      item.fieldType === "doc" ? (
                                        <div
                                          key={i}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span className="badge bg-secondary">
                                            {item.fieldName}
                                          </span>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#apmc_modal"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() =>
                                              setSelectedDocId(item.fieldValue)
                                            }
                                          >
                                            <i className="ti ti-eye"></i> View
                                            Document
                                          </Link>
                                        </div>
                                      ) : (
                                        <span
                                          key={i}
                                          className="badge bg-danger-subtle text-danger"
                                        >
                                          {typeof item === "object"
                                            ? item.fieldValue
                                            : item}
                                        </span>
                                      )
                                    )
                                  ) : (
                                    <span className="badge bg-danger-subtle text-danger">
                                      {entry.oldValue.fieldValue}
                                    </span>
                                  )}
                                </div>
                                <i className="ti ti-arrow-right"></i>
                                <span className="text-danger">
                                  Updated Data:
                                </span>

                                <div className="d-flex flex-column gap-1">
                                  {Array.isArray(entry.newValue) ? (
                                    entry.newValue.map((item, i) =>
                                      typeof item === "object" &&
                                      item.fieldType === "doc" ? (
                                        <div
                                          key={i}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span className="badge bg-success">
                                            {item.fieldName}
                                          </span>
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#apmc_modal"
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() =>
                                              setSelectedDocId(item.fieldValue)
                                            }
                                          >
                                            <i className="ti ti-eye"></i> View
                                            Document
                                          </Link>
                                        </div>
                                      ) : (
                                        <span
                                          key={i}
                                          className="badge bg-danger-subtle text-danger"
                                        >
                                          {typeof item === "object"
                                            ? item.fieldValue
                                            : item}
                                        </span>
                                      )
                                    )
                                  ) : (
                                    <span className="badge bg-danger-subtle text-danger">
                                      {entry.newValue.fieldValue}
                                    </span>
                                  )}
                                </div>
                              </div>}
                              {entry.isVerified && (
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <span className="text-success">Verified:</span>
                                  <i className="ti ti-check text-success"></i>
                                  
                                  <span className="text-success">
                                    {entry.isVerified===true ? "Yes" : "No"}
                                  </span>
                                </div>
                              )}
                               {entry.comment && (
                                <div className="bg-primary-subtle text-dark rounded p-2 d-flex align-items-start gap-2">
                                  <i className="ti ti-message mt-1"></i>
                                  <span>{entry.comment}</span>
                                </div>
                              )}
                              <div className="d-flex align-items-center gap-2 mb-2">
                                <span className="text-muted">Status:</span>
                                <span className="badge bg-warning-subtle text-dark fs-14">
                                  {entry.status}
                                </span>
                              </div>
                             
                            </div>
                          )
                        )
                      )
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      <SingleView docId={selectedDocId} type="form" datafield={dataField}/>
      {/* <ApplicationTimelineModal comments={transaction} /> */}
    </>
  );
};

export default RejPage;
